import * as React from 'react';
import Button from 'material-ui/Button/index';
import { CONSTANTS } from '../../assets/UIConstants';
import { CSSProperties } from 'react';

type ButtonVariants = 'flat' | 'raised' | 'fab' | undefined;

interface ButtonProps {
    style?: React.CSSProperties;
    onClick?: () => void;
    isDisabled?: boolean;
    isFullWidth?: boolean;
    isPrimary?: boolean;
    isFab?: boolean;
    isRaised?: boolean;
    disableFocusRipple?: boolean;
    isMini?: boolean;
    disableRipple?: boolean;
    type?: string;
}

export default class CustomButton extends React.Component<ButtonProps, {}> {

    public render(): React.ReactNode {
        let variant: ButtonVariants;
        if (this.props.isFab) {
            variant = 'fab';
        }
        if (this.props.isRaised) {
            variant = 'raised';
        }

        return (
            <Button 
                style={this.computedStyle()}
                onClick={this.props.onClick}
                type={this.props.type}
                disableRipple={this.props.disableRipple}
                disableFocusRipple={this.props.disableFocusRipple}
                mini={this.props.isMini}
                disabled={this.props.isDisabled}
                variant={variant}
            >
                {this.props.children}
            </Button>
        );
    }

    private computedStyle(): React.CSSProperties {
        let out: React.CSSProperties = {};

        out = ButtonStyle;

        if (this.props.isFullWidth) {
            out = {...out, ...fullWidthButtonStyle};
        }

        if (this.props.isPrimary) {
            out = {...out, ...PrimaryButtonStyle};
        }

        if (this.props.isPrimary && this.props.isDisabled) { 
            out = {...out, ...PrimaryButtonDisabledStyle};
        }
        
        if (undefined != this.props.style) {
            out = {...out, ...this.props.style};
        }

        return out;
    }
}

export const ButtonStyle: CSSProperties = {
    height: 43,
    appearance: 'none',
    border: `1px solid ${CONSTANTS.COLORS.BUTTON_OUTLINE_GREY}`,
    fontFamily: CONSTANTS.FONT_FAMILY,
    fontSize: CONSTANTS.FONT_SIZE.DEFAULT,
    padding: '10px 20px',
    borderRadius: 6,
    boxShadow: CONSTANTS.BOX_SHADOW.BUTTON,
};

export const PrimaryButtonStyle: CSSProperties = {
    backgroundColor: CONSTANTS.COLORS.THEME_BLUE,
    color: 'white'
};

export const PrimaryButtonDisabledStyle: CSSProperties = {
    backgroundColor: CONSTANTS.COLORS.THEME_BLUE_DISABLED
};

export const fullWidthButtonStyle: CSSProperties = {
    width: '100%'
};

export const ButtonWithIconStyle: CSSProperties = {
    paddingTop: 10
};

export const ButtonWithOutlineStyle: CSSProperties = {
    border: `2px solid ${CONSTANTS.COLORS.BORDER_GREY}`,
    backgroundColor: CONSTANTS.COLORS.WHITE
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/Button.tsx